import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface TogglePublishedArtifactParams {
  artifactId: string;
  versionNumber: number;
}

export const useTogglePublishedArtifact = (matterId?: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ artifactId, versionNumber }: TogglePublishedArtifactParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { versionNumber },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/artifacts/${artifactId}/toggle-published`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Toggling artifact publish status failed');
      }
      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.KimArtifacts, { subsetId }]);
        queryClient.invalidateQueries([QueryEntity.KimPublishedArtifacts, { subsetId }]);
        queryClient.invalidateQueries([QueryEntity.KimMessages, { subsetId }]);
      },
      onError: () => {
        toast.error('Failed to update artifact. Please try again.');
      },
    },
  );
};
